<template>
  <div class="app">
    <PortalInitialization v-if="isAuthenticatingClient" />
    <Error500 v-if="isClientAuthenticationFailed" />
    <div v-if="isClientAuthenticated" :class="{blured:isModalOpened}">
      <AppHeader />
      <router-view :class="{'promotion-footer-container': skin === 'jabe' }" />
      <VasLoginModalBlueTheme ref="loginModal" v-if="skin === 'cloob' || skin === 'jabe'"/>
      <VasConfigurableLoginModal ref="loginModal" v-if="vasLoginVersion === 'v2'"/>
      <VasLoginModal ref="loginModal" v-else />
      <VasUnsubModal ref="mciUnsubModal" />
    </div>
    <ModalHost v-if="(isClientAuthenticated && isModalOpened)" />
    <div class="blured main-acrylic-background">
      <img src="@/assets/PortalAcrylicBG.jpg">
    </div>
    <button v-if="!isOnTop && skin !== 'jabe'" @click="scrollToTop" class="scroll-to-top">
      <i class="icon-previous"></i>
    </button>
  </div>
</template>
<script>
import Vue from "vue";
  import { mapGetters, mapActions } from "vuex";
  import PortalInitialization from "@/components/PortalInitialization";
  import Error500 from "@/components/Error500";
  import AppHeader from "@/components/Header";
  import VasLoginModal from "@/components/VasLoginModal.vue";
  import VasConfigurableLoginModal from "@/components/VasConfigurableLoginModal.vue";
  import VasLoginModalBlueTheme from "@/components/VasLoginModalBlueTheme.vue";
  import VasUnsubModal from "@/components/VasUnsubModal.vue";
  import rootAccessor from "@/mixins/root-accessor.js";
  import ModalHost from "@/components/ModalHost";
  import gaLoader from "@/mixins/ga-loader";
  import gtmLoader from "@/mixins/gtm-loader";
  import { constants } from "crypto";

 export default {
    name: "DefaultContainer",
    components: {
      PortalInitialization,
      Error500,
      AppHeader,
      VasLoginModal,
      VasConfigurableLoginModal,
      VasLoginModalBlueTheme,
      VasUnsubModal,
      ModalHost
    },
    data() {
      return {
        isLoading: false,
        isShowingPhoneNumberInput: true,
        isShowingPinInput: false,
        userUniqueIdentifier: "",
        userName: "",
        PhoneNumberInputText: "security.phoneNumberInputText",
        requestResult: {},
        skin: null,
        vasLoginVersion: null,
        queryUsername : null,
        isOnTop: true
      };
    },
    mixins: [rootAccessor, gaLoader, gtmLoader],
    computed: {
      ...mapGetters({
        isClientAuthenticated: "auth/isClientAuthenticated",
        isAuthenticatingClient: "auth/isAuthenticatingClient",
        isClientAuthenticationFailed: "auth/isClientAuthenticationFailed",
        portalConfigurations: "tenantDesign/config",
        isModalOpened: "modalManager/isOpen",
        modalComponent: "modalManager/component",
        isLoggingIn: "navigation/isLoggingIn",
        userToken: 'auth/userToken'
      }),
      portalGeneralInfo() {
        return this.portalConfigurations.general;
      },
      modalComponentName() {
        return Envelope;
      }
    },
    watch: {
      $route (to, from){
        this.setMetasInner()
      },
      portalGeneralInfo: function () {
        this.getQueryUsername()
        this.skin = this.portalGeneralInfo.Skin
        this.vasLoginVersion = this.portalGeneralInfo.vasLoginVersion
        this.setMetasInner()
        this.addDataAttribute("data-theme", this.portalGeneralInfo.theme);
        this.initGoogleAnalytics(false);
        this.initGoogleTagManager();
        this.addFooterPromotion()
        this.phoneNumber = this.getCookie("userName");
        if (this.phoneNumber)
          this.checkUserSubscription();
        else if(this.userToken){
          this.loadUserSubscriptionStatus()
        }
      }
    },
   created(){
     window.addEventListener('scroll', this.showScrollBtn)
   },
   beforeDestroy() {
     window.removeEventListener("scroll", this.showScrollBtn)
   },
    methods: {
      ...mapActions({
        setMetas: "meta/update",  
        getUserStatus: "subscription/getUserStatus",
        request: "subscription/requestForSubscription",
        initSub: "subscription/init",
        verify: "subscription/verify",
        checkRequestStatus: "subscription/checkRequestStatus",
        authenticateVasUser: "auth/authenticateVasUser",
        loadUserSubscriptionStatus: 'subscription/getUserState',
        subscriptionWithUrl: "subscription/subscriptionWithUrl"
      }),
      setMetasInner () {
        this.setMetas({
          title: this.portalGeneralInfo.title,
          description: this.portalGeneralInfo.description,
          url: this.portalGeneralInfo.linkUrl,
          logo: this.portalGeneralInfo.logoUrl,
          image: this.portalGeneralInfo.logoUrl,
          imageType: 'image/png',
          twitterAccount: this.portalGeneralInfo.twitterAccount,
          twitterCard: 'summary',
          site: this.portalGeneralInfo.linkUrl,
          kind: ''
        })
      },
      getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      },
      checkUserSubscription() {
        this.isLoading = true;
        let payload = {
          userName: this.phoneNumber.replace(/%/g, "percent") 
          /* for tpay hash userNames, its making
          sure that getUserState is truely
          work. the percent word in backend 
          must be replace with "%" character  */
        };
        this.getUserStatus(payload).then(response => {
          let result = response.body.result;

          // TODO: check whether user is subscribed or not
          let userPlans = result.filter(r => r.state === "Subscribe");
          if (userPlans.length > 0) {
            this.userUniqueIdentifier = userPlans[0].userUniqueIdentifier;
            this.userName = userPlans[0].userName;
            this.login();
          } else {
            return;
          }
        });
      },
      login() {
        this.authenticateVasUser(this.userName)
          .then(response => {
            let result = response.body.result;

            if (result.resultType === "Success") {
              this.isLoading = false;
              this.close();
            } else if (result.resultType === "InvalidUserNameOrPassword") {
              // Waiting for identity user to be created
            // TODO: must remove after add vue-meta
              setTimeout(() => {
                this.login();
              }, 2000);
            } else {
              this.isLoading = false;
            }
          })
          .catch(error => {
            this.isLoading = false;
          })
          .finally(() => { });
      },
      getQueryUsername() {
        if (window.location.search) {
          let queryObj = JSON.parse('{"' + decodeURI(window.location.search.substring(1)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}')
          Object.keys(queryObj).find( item => {
            if (item.toLowerCase() === 'username' || 
              item.toLowerCase() === 'phonenumber' ||
              item.toLowerCase() === 'msisdn'){
              this.queryUsername = queryObj[item]
            }
          })
          if (this.queryUsername) {
            let params = {
              username: this.queryUsername
            }
            this.subscriptionWithUrl(params)
              .then(response => {
                var domain = window.location.host
                var nDomain = domain.split('/')[0]
                var domainArray = nDomain.split('.')
                var cookieDomain = domainArray[domainArray.length - 2] + '.' + domainArray[domainArray.length - 1]
                document.cookie = 'userName=' + this.queryUsername + ';domain=' + cookieDomain + ';path=/'
                if (this.queryUsername) {
                  this.phoneNumber = this.queryUsername
                  setTimeout(() => {
                    this.checkUserSubscription()
                  }, 2000)
                }
              })
          }
        }
      },
      showScrollBtn (e) {
        this.isOnTop = document.documentElement.scrollTop < 20
      },
      scrollToTop() {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      },
      addFooterPromotion(){
        if (this.portalGeneralInfo.hasPromotionFooter) {
          var footerPromotionElement = document.createElement('div')
          footerPromotionElement.id = this.portalGeneralInfo.promotionElementId
          footerPromotionElement.style = `
            position: fixed;
            z-index: 10;
            justify-content: center;
            display: flex;
            background: white;
            bottom: 0;`
          document.getElementById('app').style = `
            height: calc(100% - ${this.portalGeneralInfo.promotionHeight});
            position: relative;`
          document.body.appendChild(footerPromotionElement)
          let promotionHeight = this.portalGeneralInfo.promotionHeight
          var setPromotionFooterScript = document.createElement('script')
          setPromotionFooterScript.src = this.portalGeneralInfo.promotionScriptSrc
          setPromotionFooterScript.onload = function() {
            var adUnits = [
              {
                code: 'block_1995',
                placement_id: 1995,
                sizes: [window.innerWidth, promotionHeight]
              }
            ]
            Deema.buildUnits(adUnits)
          }
          document.getElementsByTagName('head')[0].appendChild(setPromotionFooterScript)
        }
      }
    }
 };
</script>
